import { useMutation, useQuery } from '@apollo/client';
import { camelCase, snakeCase } from 'lodash';
import { useMemo } from 'react';
import { GET_AI_SUMMARY_FEEDBACK, SAVE_AI_SUMMARY_FEEDBACK } from '../graphql/queries/aiSummary';
import { mapKeysDeep } from '../utilities/appHelper';
/**
 * Hook that fetches AI feedback for a given AI record and provides
 * functionality to save feedback for a given AI record.
 */
const transformAiSummaryFeedbackResponse = (items) => {
    return items.map(item => {
        if (item.feedback) {
            const feedback = mapKeysDeep(item.feedback, camelCase);
            return {
                ...item,
                feedback,
            };
        }
        return {
            ...item,
        };
    });
};
export const useAiSummaryFeedback = (spec) => {
    const { data, loading, error, refetch } = useQuery(GET_AI_SUMMARY_FEEDBACK, {
        variables: {
            spec: {
                ...spec,
            },
        },
    });
    const aiSummaryFeedbackResponse = data;
    const aiSummaryFeedbackResponseItems = useMemo(() => aiSummaryFeedbackResponse
        ? transformAiSummaryFeedbackResponse(aiSummaryFeedbackResponse?.getAiSummaryFeedback?.items)
        : [], [aiSummaryFeedbackResponse]);
    const [saveAiFeedbackMutation] = useMutation(SAVE_AI_SUMMARY_FEEDBACK);
    const saveAiFeedback = (input) => {
        const feedback = mapKeysDeep(input.feedback, snakeCase);
        input.feedback = feedback;
        return saveAiFeedbackMutation({
            variables: {
                input: {
                    ...input,
                },
            },
        }).then(result => {
            // Refetch to ensure we have the latest data
            refetch();
            return result;
        });
    };
    return {
        aiSummaryFeedbackResponse,
        aiSummaryFeedbackResponseItems,
        loading,
        error,
        refetch,
        saveAiFeedback,
    };
};
